import { render, staticRenderFns } from "./SpecialtyFirst.vue?vue&type=template&id=43780f21&scoped=true&"
import script from "./SpecialtyFirst.vue?vue&type=script&lang=js&"
export * from "./SpecialtyFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43780f21",
  null
  
)

export default component.exports